import React from 'react';
import styles from './ResultType.module.scss';

const ResultType = ({ name }) => {
    return <div className={styles.resultType}>{name}</div>;
};

export default ResultType;
